<script>
    export let message = 'Sin resultados'
    export let show = false
</script>

<style>
    .notification {
        background: #4e598c;
        color: white;
        margin-top: 16px;
        opacity: 0.9;
    }
</style>

{#if message && show}
    <div class="notification">
        { message }
    </div>
{/if}